import React from 'react'
import { useSelector } from 'react-redux'
import PaperBase from '../../../../Paper/PaperBase'
import { Typography } from '@mui/material'
import LcElemensCards from '../../../../card/LcElemensCards'
import CurriculumElementsCards from '../../../../card/CurriculumElementsCards'
import GranularStepCard from '../../../../card/GranularStepCard'

const RenderCurriculum = ({ elements, structure, lcs }) => {
  const newData = {}
  structure?.children?.map((item) => {
    newData[item._id] = {}
    newData[item._id].elements = {}

    newData[item._id].lcs = lcs.map((lc) => {
      const lcData = lc.curriculumElements[structure._id] || {};
      const lcDataElements = elements[lc._id]
      if (lcDataElements) {
        const elementsData = lcDataElements.children.find((item) => item._id === lcData?.value)
        if (elementsData) {
          const se = elementsData.elements.find((el) => el.elementStructureId === item._id)
          if (se) {
            newData[item._id].elements[lc._id] = se
          }
        }
      }
      return {
        ...lc,
        curriculumElements: {
          [item._id]: lcData?.children ? lcData.children[item._id] : {}
        }
      }
    })
    newData[item._id].structure = item
  })

  
  return (
    <>
      {Object.keys(newData).reverse()
      .filter((key) => newData[key].lcs.some((lc) => lc.curriculumElements[newData[key].structure._id]?.value))
      .map((key) => {
        return <RenderCurriculum
          key={key}
          elements={newData[key].elements}
          structure={newData[key].structure}
          lcs={newData[key].lcs}
        />
      })}
      <div className="flex flex-nowrap w-full gap-1" key={structure._id}>
        <PaperBase
          backgroundColor={structure?.primaryColor}
          color={structure?.secondaryColor}
          className='font-bold min-w-100px max-w-100px sticky left-0 z-10'
          children={structure.name}
        />
        { lcs.map((lc) => {
          const lcData = lc.curriculumElements[structure._id] || {};
          const lcDataElements = elements[lc._id]
          let elementsData = null
          if (lcDataElements) {
            elementsData = lcDataElements.children.find((item) => item._id === lcData?.value)
          }
          return (
            <PaperBase
              key={`structure-${structure._id}-lc-${lc._id}`}
              backgroundColor={structure?.primaryColor}
              color={structure?.secondaryColor}
              className={[
                'min-w-180px w-full text-ellipsis',
                lcData?.value ? '' : 'bg-lines'
              ].join(' ')}
              children={<Typography className='text-ellipsis'>{elementsData?.name || lcData?.value}</Typography>}
            />
          )
        })}
      </div>
    </>
  )
}

const FormPreview = ({ lcs }) => {
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})
  const minMarking = currentCurriculum?.marking?.find((item) => item.minValue) || {}
  const lcsElements = {};
  lcs.forEach((lc) => {
    lcsElements[lc._id] = currentCurriculum.elements
  })
  return (
    <div className='max-h-screen-modal-content overflow-auto' >
      <div className='py-1 flex flex-col gap-1 w-fit' >
        {currentCurriculum?.levels?.sort((a, b) => b.position - a.position)
          .map((item) => (
          <div className="flex flex-nowrap w-full gap-1" key={item._id}>
            <PaperBase 
              backgroundColor={minMarking?.secondaryColor}
              color={minMarking?.primaryColor}
              className='font-bold min-w-100px max-w-100px sticky left-0 z-10'
              children={item.name}
            />
            { lcs.map((lc) => {
              return (
                <GranularStepCard 
                  key={`levels-${item._id}-lc-${lc._id}`}
                  backgroundColor={lc.levels[item._id] ? minMarking?.primaryColor : null}
                  color={lc.levels[item._id] ? minMarking?.secondaryColor : null}
                  step={{ definition: lc.levels[item._id] }}
                />
              )})
            }
            
          </div>
        ))}
        <LcElemensCards currentCurriculum={currentCurriculum} lcs={lcs} width='min-w-100px max-w-100px'  />
        <CurriculumElementsCards currentCurriculum={currentCurriculum} lcs={lcs} width='min-w-100px max-w-100px' />
      </div>
    </div>
  )
}

export default FormPreview